import React, { useState } from 'react';
import { Box, Typography, Grid, CircularProgress, Container, Alert, TextField, Pagination } from '@mui/material';

import { getProjects } from '../services/api';
import useFetch from '../hooks/useFetch';

// import ProjectCard from '../components/ProjectCard';
import ProjectList from '../components/ProjectList';

const FacultyDashboard = () => {
  const { data, loading, error, execute } = useFetch(getProjects);
  const projects = data?.projects || [];
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(1);
  const PROJECTS_PER_PAGE = 6;

  const filteredProjects = (!searchQuery 
    ? projects 
    : projects.filter(project => 
        project.student?.name?.toLowerCase().includes(searchQuery.toLowerCase()) || project.student?.id?.toLowerCase().includes(searchQuery.toLowerCase())
      )
  ).sort((a, b) => {
    const idA = a.student?.id || '';
    const idB = b.student?.id || '';
    return idA.localeCompare(idB);
  });

  const totalPages = Math.ceil(filteredProjects.length / PROJECTS_PER_PAGE);
  const displayedProjects = filteredProjects.slice(
    (page - 1) * PROJECTS_PER_PAGE,
    page * PROJECTS_PER_PAGE
  );

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleProjectDelete = () => {
    // Refetch projects after deletion
    execute();
  };

  const handleProjectUpdate = () => {
    // Refetch projects after update
    execute();
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Alert severity="error">Failed to load projects. Please try again later.</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Student Projects
      </Typography>

      <Box sx={{ mb: 4 }}>
        <TextField 
          label="Filter by Student Name" 
          variant="outlined" 
          fullWidth 
          value={searchQuery}
          onChange={handleSearchChange}
        />
        <Typography variant="subtitle1" sx={{ mt: 2 }}>
          {searchQuery 
            ? `Showing ${filteredProjects.length} of ${projects.length} projects`
            : `Total Projects: ${projects.length}`
          }
        </Typography>
      </Box>
      
      {/* <Box sx={{ mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
          Assigned Projects
        </Typography>
        
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <ProjectList 
            projects={projects}
            showStudentDetails={true}
            showEvaluate={true}
            onProjectUpdate={handleProjectUpdate}
            onProjectDelete={handleProjectDelete}
          />
        )}
      </Box> */}
      
      {filteredProjects.length === 0 ? (
        <Box sx={{ textAlign: 'center', mt: 8 }}>
          <Typography variant="h6" color="textSecondary">
            No projects found.
          </Typography>
        </Box>
      ) : (
        <>
          <Grid container spacing={3}>
            
               <ProjectList 
            projects={displayedProjects}
            showStudentDetails={true}
            showEvaluate={true}
            onProjectUpdate={handleProjectUpdate}
            onProjectDelete={handleProjectDelete}
          />
          </Grid>

          {totalPages > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
              <Pagination 
                count={totalPages} 
                page={page} 
                onChange={handlePageChange} 
                color="primary" 
              />
            </Box>
          )}
        </>
      )}
    </Container>
  );
};

export default FacultyDashboard;
